import { atom } from "recoil";

export const addStateLobType = atom({
  key: "addStateLobType",
  default: false,
});
export const editStateLobType = atom({
  key: "editStateLobType",
  default: false,
});
export const rowEditIdStateLobType = atom({
  key: "rowEditIdStateLobType",
  default: null,
});
export const disableButtonStateLobType = atom({
  key: "disableButtonStateLobType",
  default: false,
});

export const selectedRowsStateLobType = atom({
  key: "selectedRowsStateLobType",
  default: [],
});

export const setFilterTextLobType = atom({
  key: "setFilterTextLobType",
  default: "",
});
